import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import UPDATE_PLAN from './../../../../graphql/UpdatePlan.graphql'
import { translate } from 'react-i18next'

class AcceptModal extends Component {
  updateOrderStatus(status) {
    const { updateCustomizedPlan, modalClose } = this.props
    updateCustomizedPlan({
      variables: {
        id: this.props.order.id,
        orderStatus: status
      }
    }).then(() => {
      modalClose()
    })
  }

  render() {
    const { modalClose, t } = this.props
    return (
      <div>
        <i className="modal-close" onClick={modalClose} />
        <div className="modal-body">
          <p>
            {t('new_order_here')}
            <br />
            {t('take_action')}
            <br />
            {t('cannot_deliver')}
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn order-action" onClick={() => this.updateOrderStatus('Approved')}>
            {t('accept')}
          </button>
          <button type="button" className="btn order-action decline" onClick={() => this.updateOrderStatus('Declined')}>
            {t('decline')}
          </button>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  translate('orders'),
  graphql(UPDATE_PLAN, {
    name: 'updateCustomizedPlan'
  })
)
export default enhance(AcceptModal)



// WEBPACK FOOTER //
// src/components/Guru/Orders/Modals/AcceptModal.jsx